export const ru = {
    no_domain: 'У моей компании нет своего домена',
    no_domain_message: 'У моей компании нет своего домена, но я хочу пользоваться вашим сервисом',
};
